import React from 'react';
import { Target, Plug, GitBranch, Gauge, CheckCircle2 } from 'lucide-react';
import { projectFit } from '../data/mock';

const iconMap = {
  Target: Target,
  Plug: Plug,
  GitBranch: GitBranch,
  Gauge: Gauge
};

const ProjectFit = () => {
  return (
    <section className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          {/* Header */}
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-bold text-[#0E3A5F] mb-4">
              {projectFit.title}
            </h2>
            <p className="text-xl text-gray-600">
              {projectFit.subtitle}
            </p>
          </div>

          {/* Criteria Grid */}
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
            {projectFit.criteria.map((criterion, index) => {
              const Icon = iconMap[criterion.icon];
              return (
                <div
                  key={index}
                  className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition-all duration-300 border-2 border-gray-100 hover:border-[#7AC943]"
                >
                  <div className="flex flex-col items-center text-center">
                    <div className="w-14 h-14 bg-gradient-to-br from-[#1F6FB2]/20 to-[#7AC943]/20 rounded-full flex items-center justify-center mb-4">
                      <Icon className="h-7 w-7 text-[#1F6FB2]" />
                    </div>
                    <h3 className="font-bold text-lg text-[#0E3A5F] mb-2">
                      {criterion.title}
                    </h3>
                    <p className="text-sm text-gray-600 leading-relaxed">
                      {criterion.description}
                    </p>
                  </div>
                </div>
              );
            })}
          </div>

          {/* Disclaimer Box */}
          <div className="bg-blue-50 border-2 border-[#1F6FB2]/30 rounded-xl p-6">
            <div className="flex items-start gap-3">
              <CheckCircle2 className="h-6 w-6 text-[#1F6FB2] flex-shrink-0 mt-1" />
              <div>
                <h4 className="font-semibold text-[#0E3A5F] mb-2">
                  Not Sure If Your Project Qualifies?
                </h4>
                <p className="text-gray-700 text-sm leading-relaxed">
                  {projectFit.disclaimer}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProjectFit;
